var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.alert_message)?_c('v-container',{staticClass:"announcement-container ma-2",attrs:{"fluid":""}},[_c('v-col',{staticClass:"text-justify announcement-col",attrs:{"cols":"10","offset-lg":"3","lg":"8","offset":"1"}},[_c('div',{staticClass:"announcement"},[_vm._v(" "+_vm._s(_vm.alert_message)+" ")])])],1):_c('v-row',{staticClass:"mt-8"})
}
var staticRenderFns = []

export { render, staticRenderFns }